"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames = require("classnames");
var theme = require("./theme.scss");
var _ = require("lodash");
var ui_1 = require("@vidazoo/ui");
var __1 = require("../../../..");
var autoCompleteListWidth = __1.getAutoCompleteListWidth ? __1.getAutoCompleteListWidth() : 500;
var ReportingFilter = /** @class */ (function (_super) {
    tslib_1.__extends(ReportingFilter, _super);
    function ReportingFilter(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onDelete = function () {
            var _a = _this.props, onDelete = _a.onDelete, filter = _a.filter;
            onDelete(filter);
        };
        _this.onAddValue = function (value, label) {
            var _a = _this.props, filter = _a.filter, onAddValue = _a.onAddValue;
            onAddValue(filter, value, label);
        };
        _this.onDeleteValue = function (value) {
            var _a = _this.props, filter = _a.filter, onDeleteValue = _a.onDeleteValue;
            onDeleteValue(filter, value);
        };
        _this.onChange = function (e) {
            var _a = _this.props, onChange = _a.onChange, filter = _a.filter;
            var _b = e.target, name = _b.name, value = _b.value;
            onChange(filter, name, value);
        };
        return _this;
    }
    ReportingFilter.prototype.getFilterKeyLabel = function () {
        var _a = this.props, filter = _a.filter, groups = _a.groups;
        var label = "Item";
        var currentGroup = _.find(groups, function (group) { return filter.key === group.value; });
        if (currentGroup) {
            label = currentGroup.label;
        }
        return "Add " + label + "...";
    };
    ReportingFilter.prototype.renderFilterOperatorsSelect = function () {
        var _a = this.props, filter = _a.filter, groups = _a.groups;
        var options = [];
        var currentGroup = _.find(groups, function (group) { return filter.key === group.value; });
        if (currentGroup) {
            options = currentGroup.operators.map(function (operator) { return ({ label: __1.FilterOperators[operator], value: operator }); });
        }
        return React.createElement(ui_1.FormSelect, { className: classnames(theme.input, theme.groups), items: options, maxItems: 5, itemValueKey: "value", itemLabelKey: "label", value: filter.operator, name: "operator", required: true, hideValidationMessage: true, onChange: this.onChange, searchable: true });
    };
    ReportingFilter.prototype.render = function () {
        var _a = this.props, index = _a.index, groups = _a.groups, filter = _a.filter;
        return (React.createElement("div", { className: theme.filter },
            React.createElement("div", { className: theme.label },
                "Filter ",
                index + 1),
            React.createElement("div", { className: theme.inputs },
                React.createElement(ui_1.FormSelect, { className: classnames(theme.input, theme.groups), items: groups, maxItems: 5, itemValueKey: "value", itemLabelKey: "label", value: filter.key, name: "key", required: true, hideValidationMessage: true, onChange: this.onChange, searchable: true }),
                this.renderFilterOperatorsSelect(),
                React.createElement(ui_1.Chips, { deepPurple: true, className: classnames(theme.input, "flex-1"), allowOrder: false, leaveOpenAfterSelect: true, allowCreate: filter.allowNew, selectValueOnBlur: filter.allowNew, dataSource: filter.filterList, itemLabelKey: filter.filterLabelKey, itemValueKey: filter.filterValueKey, chips: filter.values, maxItems: 5, searchPlaceholder: this.getFilterKeyLabel(), onSelect: this.onAddValue, onDelete: this.onDeleteValue, isLoading: filter.isLoading, autoCompleteListWidth: autoCompleteListWidth }),
                React.createElement("div", { className: theme.delete, onClick: this.onDelete },
                    React.createElement(ui_1.Icon, { iconName: "icon-delete", size: 1.8 })))));
    };
    ReportingFilter.defaultProps = {};
    return ReportingFilter;
}(React.Component));
exports.default = ReportingFilter;
